export default __webpack_public_path__ + "static/media/graph.4351bfe9.svg";